import { render, staticRenderFns } from "./assessment.view.vue?vue&type=template&id=48090323&"
import script from "./assessment.view.vue?vue&type=script&lang=ts&"
export * from "./assessment.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports